import { UserInfos } from '../interfaces/user-infos';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { UsersService } from '../services/users.service';

@Component({
selector: 'app-user-infos',
templateUrl: './user-infos.component.html',
styleUrls: ['./user-infos.component.scss']
})
export class UserInfosComponent implements OnInit {

	@BlockUI() blockUI: NgBlockUI;
	@Input() id: string;
	@Input() role: string;

	userInfos: UserInfos = {
		id : "",
		firstName: "",
		lastName: "",
		fullName: "",
		email: "",
		isActive: false,
		idOrganization: "",
		idRole: "",
		role: "",
		lastConnect: "",
		shopName : "",
		image: "",     
		description: "", 
		isFittingShop: false,
		subDomainName: "",
		isWeb: false,
        isPriseCote: false,
		geolocation: "",
		telephoneNumber: "",
		shopCity: "",
		shopCountry: "",
		shopPostalCode: "",
		shopAddress: "",
		shopAddressSup: "",
		orderProcessing: 0,
		orderFinished: 0,
		network: [],

		providerName: "",
		phone: "",
		logo: "",
		adressCity: "",
		adressCountry: "",
		adressPostalCode: "",
		adressStreet: "",
		adressState: "",
		nbProviderTotal: 0,
		nbOrderRefusee: 0,
		nbProviderSold: 0,

		mangoUserId: "",
		mangoFirstName: "",
		mangoLastName: "",
		mangoEmail: "",
		birthday: null,
		nationality: "",
		residencecountry: "",

		walletId: "",
		IDENTITY_PROOF: {
			id: "",
			raison: "",
			status: ""
		},
		ADDRESS_PROOF: {
			id: "",
			raison: "",
			status: ""
		},

		bankAccountId: "",
		bankAddress1: "",
		bankAddress2: "",
		bankCity: "",
		bankCodepostal: "",
		bankCountry: "",
		bankDetailsIBAN: "",
		bankOwnerName: "",

		bankRegion: "",
		bankbIC: "",
	}

	constructor(
		public activeModal: NgbActiveModal,
		private toastrService: ToastrService,
		private usersService: UsersService,) { }

	ngOnInit(): void {
		this.getUserInfoById();
	}

	getUserInfoById(): void{
		this.blockUI.start('Loading');
		if (this.role === 'Provider'){
			this.usersService.getProviderDetailById(this.id).subscribe(
				(res) => {
					if (res.success){
						this.userInfos = res.data as UserInfos;
						this.blockUI.stop();
					}
					else{
						this.blockUI.stop();
						if (res.errorSet.includes('INVALID_PARAMS') || res.errorSet.includes('INVALID_REQUEST')) {
							this.toastrService.error('Les paramètres sont invalides');
						} else if (res.errorSet.includes('NOTFOUND')){
							this.toastrService.error('Utilisateur non trouvé');
						} else if (res.errorSet.includes('ERROR_SERVER') || res.errorSet.includes('SERVER_ERROR')) {
							this.toastrService.error('Une erreur serveur est survenue');
						}
					}
				},
				(error) => {
					this.blockUI.stop();
					// console.error(error);
					this.toastrService.error('Une erreur s\'est produite');
				}
			);
		}
		else if (this.role === 'Shop'){
			this.usersService.getShopDetailById(this.id).subscribe(
				(res) => {
				if (res.success){
					this.userInfos = res.data as UserInfos;
					this.blockUI.stop();
				}
				else{
					this.blockUI.stop();
					if (res.errorSet.includes('INVALID_PARAMS') || res.errorSet.includes('INVALID_REQUEST')) {
						this.toastrService.error('Les paramètres sont invalides');
					} else if (res.errorSet.includes('NOTFOUND')){
						this.toastrService.error('Utilisateur non trouvé');
					} else if (res.errorSet.includes('ERROR_SERVER') || res.errorSet.includes('SERVER_ERROR')) {
						this.toastrService.error('Une erreur serveur est survenue');
					}
				}
				},
				(error) => {
					this.blockUI.stop();
					// console.error(error);
					this.toastrService.error('Une erreur s\'est produite');
				}
			);
		}
	}
}
